import {
  Component,
  OnInit,
  Injectable,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { AppsService } from "src/app/shared/services/apps.service";
import { PermissionService } from "src/app/services/permission.service";
import { ThemeConstantService } from "src/app/shared/services/theme-constant.service";
import { DatePipe } from "@angular/common";
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeRows } from "src/app/shared/utils/sanitize-export";

import { NzModalService } from "ng-zorro-antd/modal";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
@Component({
  selector: "app-drivers",
  templateUrl: "./drivers.component.html",
  styleUrls: ["./drivers.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DriversComponent implements OnInit {
  driverImagePreview: string | null = null;
  driverImageBase64: string | null = null;

  header_label = {
    name: "Drivers",
  };

  drvrnm;
  phnmb;
  lcncnmb;
  drvrid;
  doj;
  newdrvr;
  drvrslst: any;
  searchText;
  visible = false;
  // True while a driver save/update request is in flight — disables the
  // submit buttons and prevents duplicate submissions on rapid clicks.
  isSaving = false;
  visibleDriverSldr = false;
  date = null;
  crdsview: boolean;
  tblview: boolean;
  switchValue = false;
  driverform: FormGroup;
  addrvrfrm: FormGroup;
  crw_id: any;
  tntLst: any = [];
  clntDtls: any;
  selectedtenant;
  vendorList: any = [];
  showLdr = false;
  shwdrvrfrm = false;
  selectedvndr;
  colors;
  selectedDriver;
  drvrslstcolumnDefs;
  userDtls: any;
  clap_in: any;
  ShowClap: boolean = false;
  showVndr: boolean = false;
  exportActive: boolean = false;
  constructor(
    private apiSrvc: AppsService,
    private router: Router,
    private themeService: ThemeConstantService,
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private modal: NzModalService,
    public perms: PermissionService
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
    }
    this.tntLst = this.clntDtls[0].tnts;
    this.selectedtenant = this.tntLst[0].tnt_id;
    this.colors = [
      { id: 1, clr: "#00bcd4", bgClr: "#d5ffff" },
      { id: 2, clr: "#424242", bgClr: "#e0e0e0" },
      { id: 3, clr: "blue", bgClr: "#e8e8ff" },
      { id: 4, clr: "#0dd015", bgClr: "#deffde" },
      { id: 5, clr: "gray", bgClr: "#f5f5f5" },
      { id: 6, clr: "green", bgClr: "#e0fbe0" },
      { id: 7, clr: "fuchsia", bgClr: "#ffe9ff" },
      { id: 8, clr: "maroon", bgClr: "#ffe1e1" },
      { id: 9, clr: "navy", bgClr: "#e5e5ff" },
      { id: 10, clr: "olive", bgClr: "#ececc9" },
      { id: 11, clr: "orange", bgClr: "#ffe9bf" },
      { id: 12, clr: "purple", bgClr: "#ffe8ff" },
      { id: 13, clr: "red", bgClr: "#ffdfdf" },
      { id: 14, clr: "silver", bgClr: "#efefef" },
      { id: 15, clr: "teal", bgClr: "#ddffff" },
      { id: 16, clr: "#303f9f", bgClr: "#e8eaf6" },
      { id: 17, clr: "rgb(230 161 5)", bgClr: "#fff5ca" },
    ];
  }

  fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  fileExtension = ".xlsx";

  ngOnInit() {
    this.getDriversLst();
    this.gridview();
    this.getVendors();
    this.driverform = new FormGroup({
      drvr_stf_id: new FormControl(""),
      drvr_nm: new FormControl(""),
      drvr_phn_no: new FormControl(""),
      drvr_lcnce_nm: new FormControl(""),
      dt_of_jn: new FormControl(""),
      own_in: new FormControl(""),
    });

    this.addrvrfrm = new FormGroup({
      drvrnm: new FormControl(""),
      phnmb: new FormControl(""),
      drvrid: new FormControl(""),
      lcncnmb: new FormControl(""),
      doj: new FormControl(""),
      own_in: new FormControl(""),
    });
  }
  gotoDrvrSldr(evnt) {
    console.log(evnt);
    this.selectedDriver = evnt;
    this.visibleDriverSldr = true;
  }
  gridview() {
    if (this.switchValue == false) {
      this.crdsview = true;
      this.tblview = false;
    } else if (this.switchValue == true) {
      this.crdsview = false;
      this.tblview = true;
    }
  }
  getDriversLst = () => {
    const fltrData = {
      selectedtenant: this.selectedtenant,
    };
    console.log(this.selectedvndr);
    if (this.selectedvndr) {
      // tslint:disable-next-line:no-string-literal
      fltrData["selectedvndr"] = this.selectedvndr;
    } else {
      fltrData["selectedvndr"] = 0;
    }
    this.showLdr = true;
    this.apiSrvc.post(fltrData, "drivers/drivers").subscribe(
      (res) => {
        this.drvrslst = res["data"];
        this.showLdr = false;
        this.drvrslst.forEach((element, index) => {
          element["clr_obj"] = this.colors[index % this.colors.length];
          element["own_in_label"] =
            element.own_in == 1 ? "Own" : element.own_in == 2 ? "Hired" : "-";
        });
        let counter = 0;

        this.drvrslst.filter((k) => {
          // k.chk_ind = true;
          k["sno"] = ++counter;
        });

        this.drvrslstcolumnDefs = [
          { headerName: "Sno", field: "sno", alignment: "center" },
          {
            headerName: "Driver No",
            field: "crw_id",
            alignment: "center",
            hide: true,
          },
          { headerName: "Driver Name", alignment: "left", field: "crw_nm" },
          { headerName: "Type", alignment: "center", field: "own_in_label" },
          {
            headerName: "Licence No.",
            alignment: "center",
            field: "crw_lcnse_nu",
          },
          { headerName: "DOJ", alignment: "center", field: "doj" },
          { headerName: "Mobile No", field: "crw_ph", alignment: "center" },
          { headerName: "Vehicle No.", field: "asrt_nm", alignment: "center" },
          // { headerName: 'Mobile No', field: 'crw_ph', alignment: 'center' }
        ];
      },
      (err) => {
        // console.log(err);
      }
    );
  };

  opendrvrlst(data) {
    this.visible = true;
    this.crw_id = data.crw_id;

    var join_dt = new Date();
    if (data.doj && data.doj !== "00-00-0000") {
      let dt_apt = data.doj.split("-");
      join_dt.setFullYear(dt_apt[2], dt_apt[1] - 1, dt_apt[0]);
    } else {
      join_dt = null;
    }

    this.driverform.get("drvr_stf_id").setValue(data.crw_stf_id);
    this.driverform.get("drvr_nm").setValue(data.crw_nm);
    this.driverform.get("drvr_phn_no").setValue(data.crw_ph);
    this.driverform.get("drvr_lcnce_nm").setValue(data.crw_lcnse_nu);
    this.driverform.get("dt_of_jn").setValue(join_dt);
    this.driverform.get("own_in").setValue(data.own_in);
    // Set image preview for edit
    this.driverImagePreview = data.crw_img_url || null;
    this.driverImageBase64 = null;
    this.driverform["crw_img_url"] = data.crw_img_url || null;
  }
  closedrvrlst() {
    this.visible = false;
    this.driverform.reset();
    this.driverImagePreview = null;
    this.driverImageBase64 = null;
    this.getDriversLst();
  }

  // onChange(result: Date): void {
  //   console.log('onChange: ', result);
  // }
  subDrvrlst() {
    if (this.isSaving) {
      return;
    }
    if (!this.perms.canWrite()) {
      this.modal.error({
        nzTitle: "Driver Details",
        nzContent: "You do not have permission to save driver records.",
      });
      return;
    }
    let postdata = this.driverform.value;
    let crw_id = this.crw_id;
    // Attach image base64 if present
    if (this.driverImageBase64) {
      postdata.crw_img_url = this.driverImageBase64;
    } else if (this.driverImagePreview) {
      postdata.crw_img_url = this.driverImagePreview;
    }
    let rte;
    if (crw_id) {
      rte = `drivers/updatedrvr/${crw_id}`;
      this.isSaving = true;
      this.apiSrvc.put(postdata, rte).subscribe(
        (res) => {
          this.isSaving = false;
          if (res["status"] === 200) {
            this.visible = false;
            this.modal.success({
              nzTitle: "Driver Details",
              nzContent: "Sucessfully Updated",
            });
            this.driverform.reset();
            this.driverImagePreview = null;
            this.driverImageBase64 = null;
            this.getDriversLst();
          }
        },
        () => {
          this.isSaving = false;
        }
      );
    } else {
      if (this.driverImageBase64) {
        postdata.crw_img_url = this.driverImageBase64;
      } else if (this.driverImagePreview) {
        postdata.crw_img_url = this.driverImagePreview;
      }
      let addDrvrData = {
        crw_nm: postdata.drvr_nm,
        crw_ph: postdata.drvr_phn_no,
        drvr_stf_id: postdata.drvr_stf_id,
        crw_lcnse_nu: postdata.drvr_lcnce_nm,
        crw_doj: this.datepipe.transform(postdata.dt_of_jn, "yyyy-MM-dd"),
        isAtchnmts: postdata.crw_img_url ? true : false,
        crw_img_url: postdata.crw_img_url || "",
        clap_in: 0,
        selectedtenant: this.selectedtenant,
        own_in: postdata.own_in,
      };
      // console.log(addDrvrData)
      rte = `drivers/register/driver`;
      this.isSaving = true;
      this.apiSrvc.post(addDrvrData, rte).subscribe(
        (res) => {
          this.isSaving = false;
          if (res["status"] === 200) {
            this.visible = false;
            this.modal.success({
              nzTitle: "Driver Details",
              nzContent: "Sucessfully Updated",
            });
            this.driverform.reset();
            this.driverImagePreview = null;
            this.driverImageBase64 = null;
            this.getDriversLst();
          }
        },
        () => {
          this.isSaving = false;
        }
      );
    }
  }

  ontntSelect(value) {
    this.selectedtenant = value;
    this.selectedvndr = "";
    this.getVendors();
    this.getDriversLst();
  }

  getVendors() {
    if (this.userDtls.dsgns_id == 1000032) {
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      this.apiSrvc
        .get(`billing/vendors/list/${this.selectedvndr}/byId`)
        .subscribe(
          (res) => {
            console.log(res);
            if (res["status"] == 200) {
              this.vendorList = res["data"];
              this.selectedvndr = this.vendorList[0].vndr_id;
              this.getDriversLst();
            }
          },
          (err) => {
            console.log("In errorr");
          }
        );
    } else if (this.clap_in == 0 || this.clap_in == 2) {
      this.vendorList = [];
      this.selectedvndr = 0;
      this.getDriversLst();
    } else {
      this.apiSrvc
        .get(`billing/vehicle-wise/vendors/list/${this.selectedtenant}`)
        .subscribe(
          (res) => {
            if (res["status"] === 200) {
              this.vendorList = res["data"];
              // this.USER_PERMISSIONS = res['perm'][0];
              if (this.vendorList.length > 1) {
                this.selectedvndr = 0;
              } else {
                this.selectedvndr = this.vendorList[0].vndr_id;
              }
              this.getDriversLst();
            }
          },
          (err) => {
            console.log("In errorr");
          }
        );
    }
  }

  onvndrSelect(value) {
    this.selectedvndr = value;
    this.getDriversLst();
  }

  opendrvrfrm() {
    // this.shwdrvrfrm = true;
    this.visible = true;
    console.log("dddddddddddddd");
  }
  bckbtn() {
    this.visible = false;
    this.addrvrfrm.reset();
    this.driverImagePreview = null;
    this.driverImageBase64 = null;
    // this.shwdrvrfrm = false;
  }

  addDrvr() {
    if (this.isSaving) {
      return;
    }
    if (!this.perms.canWrite()) {
      this.modal.error({
        nzTitle: "Driver Details",
        nzContent: "You do not have permission to add drivers.",
      });
      return;
    }
    // Attach image base64 if present
    if (this.driverImageBase64) {
      this.addrvrfrm.value.crw_img_url = this.driverImageBase64;
    }

    if (
      this.addrvrfrm.value.drvrnm == "" ||
      this.addrvrfrm.value.drvrnm == undefined ||
      this.addrvrfrm.value.phnmb == "" ||
      this.addrvrfrm.value.phnmb == undefined ||
      this.addrvrfrm.value.doj == "" ||
      this.addrvrfrm.value.doj == undefined ||
      this.addrvrfrm.value.own_in == "" ||
      this.addrvrfrm.value.own_in == undefined
    ) {
      // (await this.toastCtrl.create({
      //   message: 'Please Check the Fields are empty',
      //   duration: 2000,
      //   position: 'top'
      // })).present();
      this.modal.error({
        nzTitle: "Driver Details",
        nzContent: "Please Check the Fields are empty",
      });
    }
    // else if (this.phnmb.length != 10) {
    else if (this.addrvrfrm.value.phnmb.toString().length != 10) {
      // (await this.alertCtrl.create({
      //   header: 'Invalid Phone Number!',
      //   subHeader: 'Please Enter 10 Digited Phone Number',
      //   buttons: ['OK']
      // })).present();
      this.modal.error({
        nzTitle: "Invalid Phone Number!",
        nzContent: "Please Enter 10 Digited Phone Number",
      });
    } else {
      console.log("aaaaaaaaaaaaaaaaaa");
      this.newdrvr = {
        crw_nm: this.addrvrfrm.value.drvrnm,
        crw_ph: this.addrvrfrm.value.phnmb,
        crw_stf_id: this.addrvrfrm.value.drvrid,
        crw_lcnse_nu: this.addrvrfrm.value.lcncnmb,
        crw_doj: this.addrvrfrm.value.doj,
        selectedtenant: this.selectedtenant,
        clap_in: this.clap_in,
        crw_img_url: this.driverImageBase64 || "",
        own_in: this.addrvrfrm.value.own_in,
      };
      this.isSaving = true;
      this.apiSrvc.post(this.newdrvr, `drivers/register/driver`).subscribe(
        (res) => {
          this.isSaving = false;
          if (res["status"] == 200) {
            this.modal.success({
              nzTitle: "Driver",
              nzContent: "Sucessfully Added",
            });
            this.visible = false;
            this.shwdrvrfrm = false;
            this.addrvrfrm.reset();
            this.driverImagePreview = null;
            this.driverImageBase64 = null;
          }
        },
        () => {
          this.isSaving = false;
        }
      );
    }
  }

  gotoSldr(dta) {
    console.log(dta.data);
    this.gotoDrvrSldr(dta.data);
  }

  onDriverImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.driverImagePreview = e.target.result;
        this.driverImageBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeDriverImage() {
    this.driverImagePreview = null;
    this.driverImageBase64 = null;
    if (this.driverform) {
      this.driverform.patchValue({ crw_img_url: null });
    }
    if (this.addrvrfrm) {
      this.addrvrfrm.patchValue({ crw_img_url: null });
    }
  }
  exlArry = [];
  export() {
    this.exlArry = [];
    // this.exportActive = true;
    // console.log(this.drvrslst);
    this.drvrslst.forEach((obj) => {
      this.exlArry.push({
        "Driver Name": obj.crw_nm,
        "Driver Phone No": obj.crw_ph,
        "Driver License": obj.crw_lcnse_nu,
        "Date of Joining": obj.doj,
        Sachivalayam: obj.svm_nm,
        "Assigned Vehicle": obj.asrt_nm,
        "Vehicle Status": obj.asrt_sts_nm,
        "Vehicle Category": obj.asrt_ctgry_nm,
      });
    });
    console.log(this.exlArry);
    // SECURITY (audit finding #9): driver names and phone numbers are free text
    // from the DB. sanitizeRows clones, so this.exlArry is not mutated.
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      sanitizeRows(this.exlArry)
    );
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer: any = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });
    let fileName = "Drivers-List";
    this.saveExcelFile(excelBuffer, fileName);
  }
  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }
  visibleDriverSldrclse() {
    this.visibleDriverSldr = false;
  }
  deldrvrlst(data) {
    if (this.isSaving) {
      return;
    }
    if (!this.perms.canDelete()) {
      this.modal.error({
        nzTitle: "Driver Details",
        nzContent: "You do not have permission to delete drivers.",
      });
      return;
    }
    this.modal.confirm({
      nzTitle: "Driver Details",
      nzContent: "Are you sure you want to delete this driver?",
      nzOkText: "Yes",
      nzOkDanger: true,
      nzCancelText: "No",
      nzOnOk: () => {
        this.isSaving = true;
        this.apiSrvc.delete(`drivers/driver/${data.crw_id}`).subscribe(
          (res) => {
            this.isSaving = false;
            if (res["status"] == 200) {
              this.modal.success({
                nzTitle: "Driver Details",
                nzContent: "Driver deleted successfully",
              });
              this.getDriversLst();
            }
          },
          () => {
            this.isSaving = false;
          }
        );
      },
    });
  }
}
